import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { calcMargin } from '@App/ui/crypto_exchange/desktop/pages/spot/components/OrderHistory/tables/OrderHistoryTable/utils/calcFunctions'

import s from './styles.module.scss'
import { InfoIcon } from '@App/static/icons/SpotOrderIcons'
import OutsideClickComponent from '@App/ui/crypto_exchange/desktop/components/common/OutsideClickHandler'
import { useState } from 'react'
import { createPortal } from 'react-dom'
import { BodyPortal } from '@App/ui/crypto_exchange/desktop/components/common/BodyPortal'
export const GeneralInfo = ({
  quantity,
  tickerDataPrice,
  leverage,
  operationType,
  currency,
  renderDetailsPopUp,
}: {
  quantity: number
  tickerDataPrice: number
  leverage: number
  operationType: 'sell' | 'buy'
  currency: string
  renderDetailsPopUp?: (margin: number) => React.ReactNode
}) => {
  const margin = calcMargin(quantity, tickerDataPrice, leverage)
  const [isOpenPopUp, setIsOpenPopUp] = useState(false)
  return (
    <div className={s.container}>
      <div className={cn(s.row, s.border)}>
        <div className={s.title}>Amount</div>{' '}
        <div className={cn(s.quantity, operationType === 'sell' ? s.negative : s.positive)}>{quantity}</div>
      </div>

      <div className={cn(s.row, s.border)}>
        <div className={s.title}>Margin reserved</div>{' '}
        <div className={s.margin}>{getValueWithCurrency(currency, Number(margin))}</div>
      </div>

      <div className={s.row}>
        <div className={s.title}>
          Position details <InfoIcon className={s.infoIcon} onClick={() => setIsOpenPopUp(true)} />
        </div>
      </div>
      {isOpenPopUp && renderDetailsPopUp && (
        <BodyPortal>
          <OutsideClickComponent className={s.popUpContainer} handler={() => setIsOpenPopUp(false)}>
            {renderDetailsPopUp?.(Number(margin))}
          </OutsideClickComponent>
        </BodyPortal>
      )}
    </div>
  )
}
